'use strict';

var React = require('react');

var SvgImageAltMajor = function SvgImageAltMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.895 6.553c-.34-.678-1.45-.678-1.79 0l-3 6a1 1 0 1 0 1.79.894l.724-1.447h2.764l.723 1.447a1 1 0 0 0 1.789-.894l-3-6zm8.105 5.447h-2v-5a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2zm6-6h-4a1 1 0 1 0 0 2h1v5a1 1 0 1 0 2 0v-5h1a1 1 0 1 0 0-2zm-15.381 4 .381-.764.382.764h-.763z"
  }));
};

exports.SvgImageAltMajor = SvgImageAltMajor;
